module.exports = __webpack_public_path__ + "img/conteudo-card-o-deadline.f9082c44.png";